import { render, staticRenderFns } from "./NamePwdDialog.vue?vue&type=template&id=60605a58&scoped=true&"
import script from "./NamePwdDialog.vue?vue&type=script&lang=js&"
export * from "./NamePwdDialog.vue?vue&type=script&lang=js&"
import style0 from "./NamePwdDialog.vue?vue&type=style&index=0&id=60605a58&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60605a58",
  null
  
)

export default component.exports